<div class="balance-page flex flex-col flex-1 min-h-0 gap-4 mt-4 overflow-auto">
  <div class="card balance-card flex flex-col gap-4">
    <div
      class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3"
    >
      <div class="flex flex-col gap-1">
        <h2 class="balance-title">{{ 'BALANCE.TITLE' | translate }}</h2>
        <p class="balance-subtitle text-sm text-slate-500">
          {{ 'BALANCE.SUBTITLE' | translate }}
        </p>
      </div>
      <div class="balance-top-actions" *ngIf="roleId === 1; else saveOnlyTpl">
        <button
          type="button"
          mat-stroked-button
          (click)="openChatbot()"
          [disabled]="!canOpenChatbot()"
        >
          <mat-icon>smart_toy</mat-icon>
          {{ 'BALANCE.CHATBOT_BUTTON' | translate }}
        </button>
        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="save()"
          [disabled]="saving || form.invalid || !modules.length"
        >
          {{ 'COMMON.SAVE' | translate }}
        </button>
      </div>
      <ng-template #saveOnlyTpl>
        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="save()"
          [disabled]="saving || form.invalid || !modules.length"
        >
          {{ 'COMMON.SAVE' | translate }}
        </button>
      </ng-template>
    </div>

    <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-3" [formGroup]="form">
      <mat-form-field *ngIf="roleId === 1" appearance="outline" class="w-full">
        <mat-label>{{ 'BALANCE.CLIENT' | translate }}</mat-label>
        <mat-select
          formControlName="clientId"
          (selectionChange)="onClientChange($event.value)"
        >
          <mat-option [value]="null">{{
            'BALANCE.ALL_CLIENTS' | translate
          }}</mat-option>
          <mat-option *ngFor="let client of clients" [value]="client.idCliente">
            {{ client.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ 'BALANCE.FINCA' | translate }}</mat-label>
        <mat-select
          formControlName="fincaId"
          (selectionChange)="onFincaChange($event.value)"
        >
          <mat-option [value]="null">{{
            'BALANCE.ALL_FINCAS' | translate
          }}</mat-option>
          <mat-option
            *ngFor="let finca of filteredFincas"
            [value]="finca.idFinca"
          >
            {{ finca.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ 'BALANCE.MODULE' | translate }}</mat-label>
        <mat-select
          formControlName="moduleId"
          (selectionChange)="onModuleChange($event.value)"
        >
          <mat-option *ngIf="!modules.length" disabled>
            {{ 'BALANCE.NO_MODULES' | translate }}
          </mat-option>
          <mat-option *ngFor="let modulo of modules" [value]="modulo.idModule">
            {{ modulo.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-tab-group
      class="balance-tabs"
      animationDuration="0ms"
      #balanceTabs
      (selectedTabChange)="updateActiveTabClip()"
    >
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="balance-tab-label">
            <mat-icon>cloud</mat-icon>
            {{ 'BALANCE.TAB_METEO' | translate }}
          </span>
        </ng-template>
        <div class="balance-tab-panel">

    <div class="form-section">
      <div class="form-section-title">{{ 'BALANCE.SOURCE' | translate }}</div>
      <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-3" [formGroup]="form">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ 'BALANCE.SOURCE' | translate }}</mat-label>
          <mat-select formControlName="precipitationSource">
            <mat-option
              *ngFor="let option of sources"
              [value]="option.value"
              [disabled]="option.requiresPluviometer && !hasPluviometer"
            >
              {{ option.labelKey | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container
          *ngIf="form.get('precipitationSource')?.value === 'aemet'"
        >
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'BALANCE.AEMET_PROVINCE' | translate }}</mat-label>
            <mat-select
              formControlName="aemetProvince"
              (selectionChange)="onAemetProvinceChange($event.value)"
            >
              <mat-option [value]="null">
                {{ 'BALANCE.AEMET_SELECT_PROVINCE' | translate }}
              </mat-option>
              <mat-option *ngFor="let province of provinces" [value]="province">
                {{ province }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'BALANCE.AEMET_STATION' | translate }}</mat-label>
            <mat-select
              formControlName="aemetStationId"
              [disabled]="!form.get('aemetProvince')?.value"
              (selectionChange)="onAemetStationChange($event.value)"
            >
              <mat-option [value]="null">
                {{ 'BALANCE.AEMET_SELECT_STATION' | translate }}
              </mat-option>
              <mat-option *ngIf="stationsLoading" disabled>
                {{ 'BALANCE.AEMET_LOADING' | translate }}
              </mat-option>
              <mat-option *ngIf="!stationsLoading && !stations.length" disabled>
                {{ 'BALANCE.AEMET_NO_STATIONS' | translate }}
              </mat-option>
              <mat-option
                *ngIf="shouldShowSelectedStationPlaceholder()"
                [value]="form.get('aemetStationId')?.value"
              >
                {{ selectedStationLabel }}
              </mat-option>
              <mat-option
                *ngFor="let station of stations"
                [value]="station.idema"
              >
                <span
                  [matTooltip]="buildStationTooltip(station)"
                  [matTooltipDisabled]="!buildStationTooltip(station)"
                >
                  {{ formatStationLabel(station) }}
                </span>
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('aemetStationId')?.hasError('required')">
              {{ 'BALANCE.STATION_REQUIRED' | translate }}
            </mat-error>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="form.get('precipitationSource')?.value === 'siar'">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'BALANCE.SIAR_PROVINCE' | translate }}</mat-label>
            <mat-select
              formControlName="siarProvince"
              (selectionChange)="onSiarProvinceChange($event.value)"
            >
              <mat-option [value]="null">
                {{ 'BALANCE.SIAR_SELECT_PROVINCE' | translate }}
              </mat-option>
              <mat-option
                *ngFor="let province of siarProvinces"
                [value]="province.id"
              >
                {{ province.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'BALANCE.SIAR_STATION' | translate }}</mat-label>
            <mat-select
              formControlName="siarStationId"
              [disabled]="!form.get('siarProvince')?.value"
              (selectionChange)="onSiarStationChange($event.value)"
            >
              <mat-option [value]="null">
                {{ 'BALANCE.SIAR_SELECT_STATION' | translate }}
              </mat-option>
              <mat-option *ngIf="siarStationsLoading" disabled>
                {{ 'BALANCE.SIAR_LOADING' | translate }}
              </mat-option>
              <mat-option
                *ngIf="!siarStationsLoading && !siarStations.length"
                disabled
              >
                {{ 'BALANCE.SIAR_NO_STATIONS' | translate }}
              </mat-option>
              <mat-option
                *ngIf="shouldShowSelectedSiarStationPlaceholder()"
                [value]="form.get('siarStationId')?.value"
              >
                {{ selectedSiarStationLabel }}
              </mat-option>
              <mat-option
                *ngFor="let station of siarStations"
                [value]="station.id"
              >
                {{ formatSiarStationLabel(station) }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('siarStationId')?.hasError('required')">
              {{ 'BALANCE.SIAR_STATION_REQUIRED' | translate }}
            </mat-error>
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div class="form-section">
      <div class="form-section-title">
        {{ 'BALANCE.ETO_TITLE' | translate }}
      </div>
      <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-3" [formGroup]="form">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ 'BALANCE.ETO_SOURCE' | translate }}</mat-label>
          <mat-select formControlName="etoSource">
            <mat-option value="open_meteo">{{
              'BALANCE.SOURCES.OPEN_METEO' | translate
            }}</mat-option>
            <mat-option value="aemet">{{
              'BALANCE.SOURCES.AEMET' | translate
            }}</mat-option>
            <mat-option value="siar">{{
              'BALANCE.SOURCES.SIAR' | translate
            }}</mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="form.get('etoSource')?.value === 'aemet'">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{
              'BALANCE.ETO_AEMET_PROVINCE' | translate
            }}</mat-label>
            <mat-select
              formControlName="etoAemetProvince"
              (selectionChange)="onEtoAemetProvinceChange($event.value)"
            >
              <mat-option [value]="null">
                {{ 'BALANCE.AEMET_SELECT_PROVINCE' | translate }}
              </mat-option>
              <mat-option *ngFor="let province of provinces" [value]="province">
                {{ province }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'BALANCE.ETO_AEMET_STATION' | translate }}</mat-label>
            <mat-select
              formControlName="etoAemetStationId"
              [disabled]="!form.get('etoAemetProvince')?.value"
              (selectionChange)="onEtoAemetStationChange($event.value)"
            >
              <mat-option [value]="null">
                {{ 'BALANCE.AEMET_SELECT_STATION' | translate }}
              </mat-option>
              <mat-option *ngIf="stationsLoading" disabled>
                {{ 'BALANCE.AEMET_LOADING' | translate }}
              </mat-option>
              <mat-option *ngIf="!stationsLoading && !stations.length" disabled>
                {{ 'BALANCE.AEMET_NO_STATIONS' | translate }}
              </mat-option>
              <mat-option
                *ngIf="shouldShowSelectedEtoAemetPlaceholder()"
                [value]="form.get('etoAemetStationId')?.value"
              >
                {{ selectedEtoAemetLabel }}
              </mat-option>
              <mat-option
                *ngFor="let station of stations"
                [value]="station.idema"
              >
                <span
                  [matTooltip]="buildStationTooltip(station)"
                  [matTooltipDisabled]="!buildStationTooltip(station)"
                >
                  {{ formatStationLabel(station) }}
                </span>
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="form.get('etoAemetStationId')?.hasError('required')"
            >
              {{ 'BALANCE.ETO_STATION_REQUIRED' | translate }}
            </mat-error>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="form.get('etoSource')?.value === 'siar'">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'BALANCE.ETO_SIAR_PROVINCE' | translate }}</mat-label>
            <mat-select
              formControlName="etoSiarProvince"
              (selectionChange)="onEtoSiarProvinceChange($event.value)"
            >
              <mat-option [value]="null">
                {{ 'BALANCE.SIAR_SELECT_PROVINCE' | translate }}
              </mat-option>
              <mat-option
                *ngFor="let province of siarProvinces"
                [value]="province.id"
              >
                {{ province.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'BALANCE.ETO_SIAR_STATION' | translate }}</mat-label>
            <mat-select
              formControlName="etoSiarStationId"
              [disabled]="!form.get('etoSiarProvince')?.value"
              (selectionChange)="onEtoSiarStationChange($event.value)"
            >
              <mat-option [value]="null">
                {{ 'BALANCE.SIAR_SELECT_STATION' | translate }}
              </mat-option>
              <mat-option *ngIf="siarStationsLoading" disabled>
                {{ 'BALANCE.SIAR_LOADING' | translate }}
              </mat-option>
              <mat-option
                *ngIf="!siarStationsLoading && !siarStations.length"
                disabled
              >
                {{ 'BALANCE.SIAR_NO_STATIONS' | translate }}
              </mat-option>
              <mat-option
                *ngIf="shouldShowSelectedEtoSiarPlaceholder()"
                [value]="form.get('etoSiarStationId')?.value"
              >
                {{ selectedEtoSiarLabel }}
              </mat-option>
              <mat-option
                *ngFor="let station of siarStations"
                [value]="station.id"
              >
                {{ formatSiarStationLabel(station) }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="form.get('etoSiarStationId')?.hasError('required')"
            >
              {{ 'BALANCE.ETO_STATION_REQUIRED' | translate }}
            </mat-error>
          </mat-form-field>
        </ng-container>
      </div>
    </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="balance-tab-label">
            <mat-icon>yard</mat-icon>
            {{ 'BALANCE.TAB_CROP' | translate }}
          </span>
        </ng-template>
        <div class="balance-tab-panel">

    <div class="form-section">
      <div class="form-section-title">{{ 'BALANCE.CROP' | translate }}</div>
      <div class="grid gap-4 balance-fields-grid" [formGroup]="form">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label class="balance-label-with-help">
            {{ 'BALANCE.CROP' | translate }}
            
          <app-help-popover
              [title]="'BALANCE.HELP.DC.TITLE' | translate"
              [text]="'BALANCE.HELP.DC.TEXT' | translate"
            ></app-help-popover>
          </mat-label>
          <mat-select
            formControlName="cropId"
            (selectionChange)="onCropChange($event.value)"
          >
            <mat-option [value]="null">{{
              'BALANCE.CROP_NONE' | translate
            }}</mat-option>
            <mat-option *ngFor="let crop of crops" [value]="crop.id">
              {{ formatCropLabel(crop) }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="getSelectedCrop() as selectedCrop">
          <ng-container
            *ngIf="
              selectedCrop?.iviaVariants && selectedCrop.iviaVariants.length > 1
            "
          >
            <mat-form-field appearance="outline" class="w-full">
              <mat-label class="balance-label-with-help">
                {{ 'BALANCE.IVIA_VARIANT' | translate }}
                
          <app-help-popover
              [title]="'BALANCE.HELP.DC.TITLE' | translate"
              [text]="'BALANCE.HELP.DC.TEXT' | translate"
            ></app-help-popover>
          </mat-label>
              <mat-select formControlName="iviaVariantId">
                <mat-option [value]="null">{{
                  'BALANCE.IVIA_VARIANT_DEFAULT' | translate
                }}</mat-option>
                <mat-option
                  *ngFor="let variant of selectedCrop.iviaVariants"
                  [value]="variant.id"
                >
                  {{ formatVariantLabel(variant) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </ng-container>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label class="balance-label-with-help">
            {{ 'BALANCE.DC_LABEL' | translate }}
            
          <app-help-popover
              [title]="'BALANCE.HELP.DC.TITLE' | translate"
              [text]="'BALANCE.HELP.DC.TEXT' | translate"
            ></app-help-popover>
          </mat-label>
          <input
            matInput
            type="number"
            formControlName="dc"
            step="0.01"
            min="0"
            placeholder="0.0"
          />
          <mat-error
            *ngIf="
              form.get('dc')?.hasError('positiveNumber') &&
              form.get('dc')?.touched
            "
          >
            {{ 'BALANCE.PLANT_PARAM_POSITIVE' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label class="balance-label-with-help">
            {{ 'BALANCE.DF_LABEL' | translate }}
            
          <app-help-popover
              [title]="'BALANCE.HELP.DF.TITLE' | translate"
              [text]="'BALANCE.HELP.DF.TEXT' | translate"
            ></app-help-popover>
          </mat-label>
          <input
            matInput
            type="number"
            formControlName="df"
            step="0.01"
            min="0"
            placeholder="0.0"
          />
          <mat-error
            *ngIf="
              form.get('df')?.hasError('positiveNumber') &&
              form.get('df')?.touched
            "
          >
            {{ 'BALANCE.PLANT_PARAM_POSITIVE' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label class="balance-label-with-help">
            {{ 'BALANCE.DP_LABEL' | translate }}
            
          <app-help-popover
              [title]="'BALANCE.HELP.DP.TITLE' | translate"
              [text]="'BALANCE.HELP.DP.TEXT' | translate"
            ></app-help-popover>
          </mat-label>
          <input
            matInput
            type="number"
            formControlName="dp"
            step="0.01"
            min="0"
            placeholder="0.0"
          />
          <mat-error
            *ngIf="
              form.get('dp')?.hasError('positiveNumber') &&
              form.get('dp')?.touched
            "
          >
            {{ 'BALANCE.PLANT_PARAM_POSITIVE' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="text-sm text-amber-700" *ngIf="!hasCropSelected()">
        {{ 'BALANCE.CROP_WARNING' | translate }}
      </div>
      <div class="text-sm text-amber-700" *ngIf="hasIncompletePlantingParams()">
        {{ 'BALANCE.PLANT_PARAMS_MISSING' | translate }}
      </div>
      <div class="text-sm text-slate-500">
        {{ 'BALANCE.PLANT_PARAMS_NOTE' | translate }}
      </div>
    </div>

    <app-agronomic-configuration
      [moduleId]="getSelectedModuleId()"
    ></app-agronomic-configuration>

    <div class="form-section">
      <div class="form-section-title">
        {{ 'BALANCE.IRRIGATION.TITLE' | translate }}
      </div>
      <div
        class="grid gap-4 balance-fields-grid"
        [formGroup]="form"
      >
        <mat-form-field appearance="outline" class="w-full">
          <mat-label class="balance-label-with-help">
            {{ 'BALANCE.IRRIGATION.EMITTERS_PER_PLANT' | translate }}
            
          <app-help-popover
              [title]="'BALANCE.HELP.EMITTERS.TITLE' | translate"
              [text]="'BALANCE.HELP.EMITTERS.TEXT' | translate"
            ></app-help-popover>
          </mat-label>
          <input
            matInput
            type="number"
            formControlName="emittersPerPlant"
            step="1"
            min="1"
            placeholder="0"
          />
          <mat-error
            *ngIf="
              form.get('emittersPerPlant')?.hasError('positiveNumber') &&
              form.get('emittersPerPlant')?.touched
            "
          >
            {{ 'BALANCE.IRRIGATION.REQUIRED_FOR_HOURS' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label class="balance-label-with-help">
            {{ 'BALANCE.IRRIGATION.EMITTER_FLOW_LPH' | translate }}
            
          <app-help-popover
              [title]="'BALANCE.HELP.FLOW.TITLE' | translate"
              [text]="'BALANCE.HELP.FLOW.TEXT' | translate"
            ></app-help-popover>
          </mat-label>
          <input
            matInput
            type="number"
            formControlName="emitterFlowLph"
            step="0.1"
            min="0"
            placeholder="0.0"
          />
          <mat-error
            *ngIf="
              form.get('emitterFlowLph')?.hasError('positiveNumber') &&
              form.get('emitterFlowLph')?.touched
            "
          >
            {{ 'BALANCE.IRRIGATION.REQUIRED_FOR_HOURS' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label class="balance-label-with-help">
            {{ 'BALANCE.IRRIGATION.EA' | translate }}
            
          <app-help-popover
              [title]="'BALANCE.HELP.EA.TITLE' | translate"
              [text]="'BALANCE.HELP.EA.TEXT' | translate"
            ></app-help-popover>
          </mat-label>
          <input
            matInput
            type="number"
            formControlName="installationEfficiencyEa"
            step="1"
            min="1"
            max="100"
            placeholder="0"
          />
          <mat-error
            *ngIf="
              form.get('installationEfficiencyEa')?.hasError('percentRange') &&
              form.get('installationEfficiencyEa')?.touched
            "
          >
            {{ 'BALANCE.IRRIGATION.PERCENT_RANGE' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label class="balance-label-with-help">
            {{ 'BALANCE.IRRIGATION.CP' | translate }}
            
          <app-help-popover
              [title]="'BALANCE.HELP.CP.TITLE' | translate"
              [text]="'BALANCE.HELP.CP.TEXT' | translate"
            ></app-help-popover>
          </mat-label>
          <input
            matInput
            type="number"
            formControlName="parcelCoefficientCp"
            step="1"
            min="1"
            max="100"
            placeholder="0"
          />
          <mat-error
            *ngIf="
              form.get('parcelCoefficientCp')?.hasError('percentRange') &&
              form.get('parcelCoefficientCp')?.touched
            "
          >
            {{ 'BALANCE.IRRIGATION.PERCENT_RANGE' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="text-sm text-amber-700 mt-1">
        {{ 'BALANCE.IRRIGATION.MISSING_PARAMS_WARNING' | translate }}
      </div>
    </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="balance-tab-label">
            <mat-icon>description</mat-icon>
            {{ 'BALANCE.TAB_REPORTS' | translate }}
          </span>
        </ng-template>
        <div class="balance-tab-panel">

    <div class="card balance-card flex flex-col gap-4">
      <div
        class="flex flex-col md:flex-row md:items-end md:justify-between gap-3"
      >
        <div class="flex flex-col gap-1">
          <h3 class="balance-section-title">
            {{ 'BALANCE.WEEKLY_TITLE' | translate }}
          </h3>
        </div>
        <div class="flex flex-wrap items-end gap-3 balance-report-controls">
          <div class="flex flex-wrap items-end gap-3" [formGroup]="rangeForm">
            <mat-form-field
              appearance="outline"
              subscriptSizing="dynamic"
              class="w-full md:w-72"
            >
              <mat-label>{{ 'BALANCE.WEEK_RANGE' | translate }}</mat-label>
              <mat-date-range-input
                [rangePicker]="weekPicker"
                (dateChange)="onRangeChange($event.value)"
              >
                <input
                  matStartDate
                  formControlName="start"
                  placeholder="{{ 'BALANCE.START' | translate }}"
                />
                <input
                  matEndDate
                  formControlName="end"
                  placeholder="{{ 'BALANCE.END' | translate }}"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle
                matSuffix
                [for]="weekPicker"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #weekPicker></mat-date-range-picker>
            </mat-form-field>
            <button
              type="button"
              mat-stroked-button
              color="primary"
              class="self-end"
              (click)="refreshWeekly()"
              [disabled]="!form.get('moduleId')?.value"
            >
              {{ 'BALANCE.REFRESH' | translate }}
            </button>
          </div>
          <button
            type="button"
            mat-flat-button
            color="primary"
            class="self-end"
            (click)="openWeeklyReport()"
            [disabled]="!weeklyReport"
          >
            {{ 'BALANCE.REPORT.OPEN_BUTTON' | translate }}
          </button>
          <div class="flex items-end gap-3" *ngIf="roleId === 1">
            <mat-checkbox
              class="self-end"
              [(ngModel)]="etoDebug"
              (change)="onEtoDebugToggle()"
            >
              {{ 'BALANCE.DEBUG' | translate }}
            </mat-checkbox>
          </div>
        </div>
      </div>

      <div *ngIf="weeklyPending" class="balance-alert pending">
        {{ 'BALANCE.PENDING' | translate }}
      </div>
      <div *ngIf="weeklyError" class="balance-alert error">
        {{ weeklyError }}
      </div>
      <div
        *ngIf="weeklyMissingData && !weeklyPending && !weeklyError"
        class="balance-alert pending"
      >
        {{ 'BALANCE.WEEKLY_MISSING' | translate }}
      </div>
      <div *ngIf="etoNotImplemented" class="balance-alert pending">
        {{ 'BALANCE.ETO_NOT_IMPLEMENTED' | translate }}
      </div>
      <div *ngIf="etoError" class="balance-alert error">
        {{ etoError }}
      </div>

      <ng-container
        *ngIf="
          (weeklySummary && !weeklyPending && !weeklyError) ||
          (etoSummary && !etoNotImplemented && !etoError)
        "
      >
        <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <div class="summary-tile">
            <span class="summary-label">{{
              'BALANCE.PRECIP_TOTAL' | translate
            }}</span>
            <strong class="summary-value"
              >{{ weeklySummary?.total  ??  '-' }} mm</strong
            >
          </div>
          <div class="summary-tile">
            <span class="summary-label">{{
              'BALANCE.PRECIP_EFFECTIVE' | translate
            }}</span>
            <strong class="summary-value"
              >{{ weeklySummary?.effective  ??  '-' }} mm</strong
            >
          </div>
          <div class="summary-tile">
            <span class="summary-label">{{
              'BALANCE.ETO_WEEKLY_TITLE' | translate
            }}</span>
            <strong class="summary-value"
              >{{ etoSummary?.total  ??  '-' }} mm</strong
            >
          </div>
          <div class="summary-tile">
            <span class="summary-label">{{
              'BALANCE.ETC_WEEKLY_TITLE' | translate
            }}</span>
            <strong class="summary-value"
              >{{ etcWeeklyTotal  ??  '-' }} mm</strong
            >
          </div>
          <div class="summary-tile">
            <span class="summary-label">{{
              'BALANCE.DATA_QUALITY' | translate
            }}</span>
            <span
              class="eto-badge"
              [class.missing]="etoSummary?.dataQuality === 'missing'"
            >
              {{ formatEtoQuality(etoSummary?.dataQuality) }}
            </span>
          </div>
        </div>

        <div class="irrigation-card">
          <div class="irrigation-card__title">
            {{ 'BALANCE.IRRIGATION.RECOMMENDATION.TITLE' | translate }}
          </div>
          <div class="irrigation-grid">
            <div>
              <div class="flex items-center gap-1 summary-label">
                {{ 'BALANCE.IRRIGATION.RESULTS.GROSS_NEED' | translate }}
                <app-help-popover
                  [title]="
                    'BALANCE.IRRIGATION.RECOMMENDATION.GROSS_HELP_TITLE'
                      | translate
                  "
                  [text]="
                    'BALANCE.IRRIGATION.RECOMMENDATION.GROSS_HELP_TEXT'
                      | translate
                  "
                ></app-help-popover>
              </div>
              <div class="irrigation-value">
                <ng-container
                  *ngIf="
                    grossNeedMmWeekly !== null &&
                      grossNeedMmWeekly !== undefined &&
                      irrigationQuality !== 'missing_params';
                    else irrigationMissing
                  "
                >
                  {{ grossNeedMmWeekly | number: '1.2-2' }} mm
                </ng-container>
              </div>
            </div>
            <div>
              <div class="summary-label">
                {{ 'BALANCE.IRRIGATION.RESULTS.LITERS_PER_PLANT' | translate }}
              </div>
              <div class="irrigation-value">
                <ng-container
                  *ngIf="
                    litersPerPlantWeekly !== null &&
                      litersPerPlantWeekly !== undefined &&
                      irrigationQuality !== 'missing_params';
                    else irrigationMissing
                  "
                >
                  {{ litersPerPlantWeekly | number: '1.2-2' }} L/planta
                </ng-container>
              </div>
            </div>
            <div>
              <div class="summary-label">
                {{ 'BALANCE.IRRIGATION.RESULTS.HOURS' | translate }}
              </div>
              <div class="irrigation-value">
                <ng-container
                  *ngIf="
                    irrigationHoursPerPlantWeekly !== null &&
                      irrigationHoursPerPlantWeekly !== undefined &&
                      irrigationQuality !== 'missing_params';
                    else irrigationMissing
                  "
                >
                  {{ formatIrrigationHours(irrigationHoursPerPlantWeekly) }}
                  <div class="irrigation-sub">
                    ({{ irrigationHoursPerPlantWeekly | number: '1.2-2' }} h)
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <ng-template #irrigationMissing>
            <span>—</span>
          </ng-template>
          <div
            *ngIf="irrigationQuality === 'missing_params'"
            class="text-sm text-amber-700 mt-2"
          >
            {{
              'BALANCE.IRRIGATION.RECOMMENDATION.MISSING_PARAMS_WARNING'
                | translate
            }}
          </div>
        </div>

        <div
          class="text-sm text-slate-500"
          *ngIf="weeklySummary || etoSummary || weeklyKc?.length"
        >
          {{ 'BALANCE.SOURCE_LABEL' | translate }}:
          {{ weeklySummary?.source || ('BALANCE.UNKNOWN_SOURCE' | translate) }}
          | {{ 'BALANCE.ETO_SOURCE' | translate }}:
          {{ etoSummary?.source || ('BALANCE.UNKNOWN_SOURCE' | translate) }}
          | Kc:
          {{
            weeklyKc?.length
              ? weeklyKc[0]?.kcSourceUsed ||
                ('BALANCE.UNKNOWN_SOURCE' | translate)
              : ('BALANCE.UNKNOWN_SOURCE' | translate)
          }}
        </div>

        <div class="text-sm text-slate-500" *ngIf="etoSummary">
          {{ 'BALANCE.ETO_METHOD' | translate }}:
          {{ etoSummary?.method || ('BALANCE.ETO_METHOD_DEFAULT' | translate) }}
        </div>

        <div class="daily-table" *ngIf="combinedDailyRows?.length">
          <div class="daily-head">
            <span>{{ 'BALANCE.DAY' | translate }}</span>
            <span>{{ 'BALANCE.PRECIP_TOTAL' | translate }}</span>
            <span>{{ 'BALANCE.ETO_DAILY' | translate }}</span>
            <span>{{ 'BALANCE.KC' | translate }}</span>
            <span>{{ 'BALANCE.ETC_DAILY' | translate }}</span>
          </div>
          <div class="daily-row" *ngFor="let day of combinedDailyRows">
            <span>{{ day.date | date: 'yyyy-MM-dd' }}</span>
            <span
              >{{
                day.precip === null || day.precip === undefined
                  ? '-'
                  : (day.precip | number: '1.2-2')
              }}
              mm</span
            >
            <span
              >{{
                day.eto === null || day.eto === undefined
                  ? '-'
                  : (day.eto | number: '1.2-2')
              }}
              mm</span
            >
            <span>
              {{
                day.kc === null || day.kc === undefined
                  ? '-'
                  : (day.kc | number: '1.3-3')
              }}
              <div
                class="text-xs text-slate-500"
                *ngIf="
                  etoDebug && (day.kcSource || day.kcPas || day.kcMonthFactor)
                "
              >
                {{ 'BALANCE.KC_SOURCE_USED' | translate }}:
                {{ formatKcSource(day.kcSource) }}
                <span
                  *ngIf="
                    formatKcSource(day.kcSource) === 'IVIA' &&
                    (day.kcIviaCropName || day.kcIviaVariantIdUsed)
                  "
                >
                  | {{ day.kcIviaCropName || 'IVIA' }}
                  <span *ngIf="day.kcIviaVariantIdUsed">
                    ({{ 'BALANCE.IVIA_VARIANT' | translate }}:
                    {{ day.kcIviaVariantIdUsed }})</span
                  >
                </span>
                <span *ngIf="day.kcPas">
                  | PAs: {{ day.kcPas | number: '1.2-2' }}</span
                >
                <span *ngIf="day.kcMonthFactor">
                  | {{ 'BALANCE.KC_MONTH_FACTOR' | translate }}:
                  {{ day.kcMonthFactor | number: '1.2-2' }}</span
                >
              </div>
            </span>
            <span
              >{{
                day.etc === null || day.etc === undefined
                  ? '-'
                  : (day.etc | number: '1.2-2')
              }}
              mm</span
            >
          </div>
        </div>

        <div class="text-sm text-slate-500" *ngIf="!combinedDailyRows?.length">
          {{ 'BALANCE.NO_DAILY' | translate }}
        </div>
      </ng-container>

      <div
        *ngIf="
          !weeklySummary &&
          !weeklyPending &&
          !weeklyError &&
          !etoSummary &&
          !etoNotImplemented &&
          !etoError
        "
        class="text-sm text-slate-500"
      >
        {{ 'BALANCE.NO_SUMMARY' | translate }}
      </div>
      <div *ngIf="etoDebug && etoSummary?.diagnostics" class="eto-diagnostics">
        <div class="text-sm text-slate-500">
          {{ 'BALANCE.DEBUG' | translate }}
        </div>
        <div class="eto-diagnostics-grid">
          <div *ngFor="let item of formatDiagnostics(etoSummary?.diagnostics)">
            <strong>{{ item.key }}:</strong> {{ item.value }}
          </div>
        </div>
      </div>
      <div *ngIf="etoDebug && irrigationDiagnostics" class="eto-diagnostics">
        <div class="text-sm text-slate-500">
          {{ 'BALANCE.DEBUG' | translate }}
        </div>
        <div class="eto-diagnostics-grid">
          <div *ngIf="irrigationDiagnostics?.missingParams?.length">
            <strong>missingParams:</strong>
            {{ irrigationDiagnostics?.missingParams.join(', ') }}
          </div>
          <div *ngIf="irrigationDiagnostics?.eff !== undefined">
            <strong>eff:</strong> {{ irrigationDiagnostics?.eff }}
          </div>
          <div *ngIf="irrigationDiagnostics?.areaPerPlantM2 !== undefined">
            <strong>areaPerPlantM2:</strong>
            {{ irrigationDiagnostics?.areaPerPlantM2 }}
          </div>
          <div *ngIf="irrigationDiagnostics?.flowPerPlantLph !== undefined">
            <strong>flowPerPlantLph:</strong>
            {{ irrigationDiagnostics?.flowPerPlantLph }}
          </div>
        </div>
      </div>
    </div>
        </div>
      </mat-tab>
    </mat-tab-group>

  </div>

  <ng-template #chatbotDialog>
    <h2 mat-dialog-title class="chatbot-title">
      <div class="chatbot-header">
        <div class="chatbot-header-left">
          <div class="chatbot-title-row">
            <mat-icon aria-hidden="true">smart_toy</mat-icon>
            <span class="balance-section-title">{{
              'BALANCE.CHATBOT_DIALOG_TITLE' | translate
            }}</span>
          </div>
          <span class="text-sm text-slate-500 chatbot-module-line">
            {{ 'BALANCE.CHATBOT_MODULE_CONTEXT' | translate }}:
            {{ getSelectedModuleName() }}
          </span>
          <span class="chatbot-status" [class.simulated]="chatMeta?.simulated">
            {{ getChatStatusLabel() }}
          </span>
        </div>
        <button
          mat-icon-button
          type="button"
          aria-label="Close"
          class="chatbot-close-btn"
          (click)="closeChatbot()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </h2>
    <mat-dialog-content class="chatbot-dialog-content">
      <div *ngIf="chatError" class="chatbot-inline-error">
        {{ chatError }}
      </div>

      <div #chatbotScroll class="chatbot-messages">
        <div class="chatbot-empty" *ngIf="!chatMessages.length && !chatSending">
          {{ 'BALANCE.CHATBOT_EMPTY' | translate }}
        </div>

        <div
          class="chat-message"
          *ngFor="let msg of chatMessages; trackBy: trackByChatMessage"
          [class.user]="msg.role === 'user'"
          [class.assistant]="msg.role === 'assistant'"
          [class.error]="msg.isError"
        >
          <div class="chat-bubble" [class.has-rich-content]="hasRenderableBlocks(msg)">
            <ng-container *ngIf="hasRenderableBlocks(msg); else legacyChatText">
              <div class="chat-blocks">
                <ng-container
                  *ngFor="
                    let block of msg.renderBlocks || [];
                    let i = index;
                    trackBy: trackByChatBlock
                  "
                >
                  <div
                    class="chat-text"
                    *ngIf="isTextRenderBlock(block)"
                    [innerHTML]="renderChatBlockMarkdown(msg, block, i)"
                  ></div>
                  <app-agent-chat-chart-block
                    *ngIf="isChartRenderBlock(block)"
                    [block]="block"
                    (chartRendered)="onChatChartRendered()"
                  ></app-agent-chat-chart-block>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #legacyChatText>
              <div class="chat-text" [innerHTML]="renderChatMarkdown(msg)"></div>
            </ng-template>
            <div class="chat-time">{{ msg.createdAt | date: 'HH:mm' }}</div>
          </div>
        </div>

        <div class="chat-message assistant typing" *ngIf="chatSending">
          <div class="chat-bubble">
            <div class="chat-text">{{ 'BALANCE.CHATBOT_TYPING' | translate }}</div>
          </div>
        </div>
      </div>

      <div class="chatbot-footer">
        <mat-form-field appearance="outline" class="chatbot-input">
          <mat-label>{{ 'BALANCE.CHATBOT_INPUT_LABEL' | translate }}</mat-label>
          <textarea
            matInput
            rows="3"
            [(ngModel)]="chatInput"
            (keydown)="onChatInputKeydown($event)"
            [disabled]="chatSending || !canOpenChatbot()"
            [placeholder]="'BALANCE.CHATBOT_INPUT_PLACEHOLDER' | translate"
          ></textarea>
        </mat-form-field>
        <button
          mat-flat-button
          color="primary"
          class="chatbot-send-btn"
          type="button"
          (click)="sendChatMessage()"
          [disabled]="!canSendChatMessage()"
        >
          <mat-icon>send</mat-icon>
          {{ 'BALANCE.CHATBOT_SEND' | translate }}
        </button>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button type="button" (click)="closeChatbot()">
        {{ 'COMMON.CLOSE' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #weeklyReportDialog>
    <h2 mat-dialog-title class="flex items-start justify-between gap-3">
      <div class="flex flex-col">
        <span class="balance-section-title">{{
          'BALANCE.REPORT.TITLE' | translate
        }}</span>
        <span class="text-sm text-slate-500" *ngIf="rangeForm?.value">
          {{ rangeForm?.value?.start | date: 'yyyy-MM-dd' }} –
          {{ rangeForm?.value?.end | date: 'yyyy-MM-dd' }}
        </span>
      </div>
      <button
        mat-icon-button
        type="button"
        aria-label="Close"
        (click)="closeWeeklyReport()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content class="flex flex-col gap-4 report-dialog-content">
      <div *ngIf="operationalSummary?.length" class="card p-3 report-callout">
        <div class="font-semibold text-slate-700 mb-2">
          {{ 'BALANCE.REPORT.OPERATIONS.TITLE' | translate }}
        </div>
        <ul class="list-disc pl-4 space-y-1 text-sm text-slate-700">
          <li *ngFor="let line of operationalSummary">
            {{ line.key | translate: line.params }}
          </li>
        </ul>
      </div>
      <div
        *ngIf="weeklyReport?.features; else reportLoading"
        class="grid gap-3 md:grid-cols-2 xl:grid-cols-4"
      >
        <div class="summary-tile">
          <span class="summary-label">{{
            'BALANCE.REPORT.WEEKLY.THEORETICAL' | translate
          }}</span>
          <div class="summary-value text-sm">
            <div>
              {{ 'BALANCE.REPORT.LABEL.GROSS_NEED' | translate }}:
              {{ formatNumber(weeklyReport?.features?.theoretical?.grossNeedMmWeekly) ?? '—' }}
            </div>
            <div>
              {{ 'BALANCE.REPORT.LABEL.LITERS_PER_TREE' | translate }}:
              {{ formatNumber(weeklyReport?.features?.theoretical?.litersPerPlantWeekly) ?? '—' }}
            </div>
            <div>
              {{ 'BALANCE.REPORT.LABEL.HOURS_PER_TREE' | translate }}:
              {{ formatNumber(weeklyReport?.features?.theoretical?.irrigationHoursPerPlantWeekly, '1.0-1') ?? '—' }}
            </div>
          </div>
        </div>
        <div class="summary-tile">
          <span class="summary-label">{{
            'BALANCE.REPORT.WEEKLY.ACTUAL' | translate
          }}</span>
          <div class="summary-value text-sm">
            <div>
              {{ 'BALANCE.REPORT.LABEL.LITERS_PER_TREE' | translate }}:
              {{ formatNumber(weeklyReport?.features?.realIrrigation?.litersPerTreeTotal ?? weeklyReport?.features?.realIrrigation?.litersPerTree) ?? '—' }}
            </div>
            <div>
              {{ 'BALANCE.REPORT.LABEL.EVENTS' | translate }}:
              {{ weeklyReport?.features?.realIrrigation?.eventsCount ?? '—' }}
            </div>
            <div>
              {{ 'BALANCE.REPORT.LABEL.CONFIDENCE' | translate }}:
              {{
                formatConfidence(
                  weeklyReport?.features?.realIrrigation?.confidence
                )
              }}
            </div>
          </div>
        </div>
        <div class="summary-tile">
          <span class="summary-label">{{
            'BALANCE.REPORT.WEEKLY.COMPARISON' | translate
          }}</span>
          <div class="summary-value text-sm">
            <div>
              {{ 'BALANCE.REPORT.LABEL.COMPARISON_BASE' | translate }}:
              {{
                formatComparisonBasis(weeklyReport?.features?.comparison?.basis)
              }}
            </div>
            <div>
              {{ 'BALANCE.REPORT.LABEL.RATIO' | translate }}:
              {{
                formatComparisonRatio(weeklyReport?.features?.comparison?.ratio)
              }}
            </div>
            <div
              *ngIf="
                weeklyReport?.features?.comparison?.diffPct !== null &&
                weeklyReport?.features?.comparison?.diffPct !== undefined
              "
            >
              {{ 'BALANCE.REPORT.LABEL.DIFF' | translate }}:
              {{ formatComparisonDiff(weeklyReport?.features?.comparison?.diffPct) ?? '—' }}
            </div>
          </div>
        </div>
        <div class="summary-tile">
          <span class="summary-label">{{
            'BALANCE.REPORT.WEEKLY.SOIL' | translate
          }}</span>
          <div class="summary-value text-sm">
            <div>
              {{ 'BALANCE.REPORT.LABEL.CONTROL_RANGE' | translate }}:
              {{
                formatControlRange(
                  weeklyReport?.features?.soil?.controlMin,
                  weeklyReport?.features?.soil?.controlMax
                )
              }}
            </div>
            <div>
              {{ 'BALANCE.REPORT.LABEL.CONTROL_AVG' | translate }}:
              {{ weeklyReport?.features?.soil?.controlAvg ?? '—' }}
            </div>
            <div
              *ngIf="
                weeklyReport?.features?.drainage?.episodesCount !== null &&
                weeklyReport?.features?.drainage?.episodesCount !== undefined
              "
            >
              {{ 'BALANCE.REPORT.LABEL.DRAINAGE' | translate }}:
              {{ weeklyReport?.features?.drainage?.episodesCount }} ·
              {{ formatNumber(weeklyReport?.features?.drainage?.durationHours, '1.0-1') ?? '—' }}
              h
            </div>
            <div
              *ngIf="weeklyReport?.context?.soilControlScale === 'index'"
              class="text-xs text-slate-500"
            >
              {{ 'BALANCE.REPORT.LABEL.CONTROL_NOTE_INDEX' | translate }}
            </div>
          </div>
        </div>
      </div>

      <ng-template #reportLoading>
        <div class="text-sm text-slate-500">
          {{ 'COMMON.LOADING' | translate }}
        </div>
      </ng-template>

      <div class="text-sm text-slate-600" *ngIf="reportNarrative?.length">
        <div class="font-semibold mb-2">
          {{ 'BALANCE.REPORT.NARRATIVE_TITLE' | translate }}
        </div>
        <ul class="list-disc pl-4 space-y-1">
          <li *ngFor="let item of reportNarrative">
            {{ item.key | translate: item.params }}
          </li>
        </ul>
      </div>

      <div
        *ngIf="weeklyReport?.insights?.length; else noFindingsModal"
        class="grid gap-3 md:grid-cols-2"
      >
        <mat-card *ngFor="let insight of weeklyReport?.insights" class="p-3">
          <div class="flex items-center justify-between mb-1">
            <div class="font-semibold">
              {{ getInsightTitle(insight) }}
            </div>
            <span class="text-xs text-slate-500">{{ insight.severity }}</span>
          </div>
          <div class="text-sm text-slate-600">
            {{ getInsightSubtitle(insight) }}
          </div>
          <mat-expansion-panel class="mt-2" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title class="text-sm">{{
                'BALANCE.REPORT.WEEKLY.DETAILS' | translate
              }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div
              class="text-xs text-slate-600 space-y-1"
              *ngIf="getInsightDetails(insight)?.length"
            >
              <div *ngFor="let row of getInsightDetails(insight)">
                <strong>{{ row.label }}:</strong> {{ row.value }}
              </div>
            </div>
            <div
              *ngIf="etoDebug && insight.evidence"
              class="text-xs text-slate-500 mt-2"
            >
              <pre
                class="p-2 whitespace-pre-wrap text-xs bg-slate-50 border border-slate-200 rounded"
                >{{ insight.evidence | json }}</pre
              >
            </div>
            <div *ngIf="insight.dimensions" class="text-xs text-slate-500 mt-1">
              dims: {{ insight.dimensions | json }}
            </div>
            <div
              *ngIf="insight.tags?.length"
              class="text-xs text-slate-500 mt-1"
            >
              tags: {{ insight.tags.join(', ') }}
            </div>
          </mat-expansion-panel>
        </mat-card>
      </div>
      <ng-template #noFindingsModal>
        <div class="text-sm text-slate-500">
          {{ 'BALANCE.REPORT.NO_FINDINGS' | translate }}
        </div>
      </ng-template>

      <div *ngIf="etoDebug && weeklyReport?.debug" class="eto-diagnostics">
        <div class="text-sm text-slate-500">
          {{ 'BALANCE.DEBUG' | translate }}
        </div>
        <div class="eto-diagnostics-grid">
          <div *ngIf="weeklyReport?.debug?.balance">
            <strong>balance:</strong> {{ weeklyReport?.debug?.balance | json }}
          </div>
          <div *ngIf="weeklyReport?.debug?.soilSignals">
            <strong>soilSignals:</strong>
            {{ weeklyReport?.debug?.soilSignals | json }}
          </div>
          <div *ngIf="weeklyReport?.debug?.flowSignals">
            <strong>flowSignals:</strong>
            {{ weeklyReport?.debug?.flowSignals | json }}
          </div>
          <div *ngIf="weeklyReport?.debug?.legacy">
            <strong>legacy:</strong> {{ weeklyReport?.debug?.legacy | json }}
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button type="button" (click)="closeWeeklyReport()">
        {{ 'COMMON.CLOSE' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
